import React from 'react';
import { CheckIcon } from '@rsos/assets/icons';
import { Box, Text } from '@rsos/components/capstone/base';

const OnsitePersonnelBanner = () => {
  // TODO: app logic for business requirements. add a selector for this to be
  // reused for the call queue item
  const isOnsitePersonnelNotified = false;

  if (!isOnsitePersonnelNotified) {
    return null;
  }
  return (
    <Box p="16px" width="100%">
      <Box p="16px" bg="success" borderRadius="5px">
        <Box horizontal align="center">
          <CheckIcon color="background" />
          <Box pl="16px">
            <Text fontWeight="bold" size="normal" color="background">
              Onsite Personnel Notified
            </Text>
            <Text size="normal" color="background">
              Call location shared w/ onsite personnel
            </Text>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default OnsitePersonnelBanner;
